// Web shim for @react-native-firebase/messaging – no-op implementations

export const AuthorizationStatus = {
  NOT_DETERMINED: 0,
  DENIED: 1,
  AUTHORIZED: 2,
  PROVISIONAL: 3,
} as const;

export type MessagingLike = {
  requestPermission: () => Promise<number>;
};

export const getMessaging = (_app?: any): MessagingLike => ({
  requestPermission: async () => AuthorizationStatus.AUTHORIZED,
});

export const onMessage = (_messaging: any, _handler: any) => {
  // Return unsubscribe function
  return () => {};
};

export const getToken = async (_messaging?: any) => null;

export const hasPermission = async (_messaging?: any) =>
  AuthorizationStatus.AUTHORIZED;

export default {
  AuthorizationStatus,
  getMessaging,
  onMessage,
  getToken,
  hasPermission,
};
